// extracted by mini-css-extract-plugin
module.exports = {"launchbutton":"style__launchbutton__5rKjs","button":"style__button__LoYRT"};